import '../../App.css';
import { Link } from 'react-router-dom';

export default function InternshipFinder() {
    return (
        <div className="min-h-screen flex flex-col">
            <div className="fixed top-0 left-0 p-4" style={{ zIndex: 60 }}>
                <Link to="/projects">
                    <button className="text-3xl p-2 rounded-full border-2 border-slate-800 text-slate-800 bg-white/80 backdrop-blur-sm hover:bg-slate-800 hover:text-white transition-colors">
                        <i className="fa-solid fa-arrow-left"></i>
                    </button>
                </Link>
            </div>
            <div className="relative">
                <div className="sticky top-0 h-[110vh] flex flex-col items-center pt-24 md:pt-28 bg-gradient-to-b from-blue-100 to-cyan-100">
                    <div className="flex justify-center bg-transparent md:pb-4">
                        <h1 className="text-5xl md:text-6xl lilita text-center text-slate-900">InternshipFinder</h1>
                    </div>
                    <div className="flex flex-col lg:flex-row items-center justify-center mt-2 md:mt-10 mx-2 md:mx-6 lg:mx-16 xl:mx-48 gap-5 lg:gap-32 object-contain">
                        <div className="flex justify-center h-[50vh] md:h-[60vh] lg:h-[70vh]">
                            <div className="w-full bg-gradient-to-br from-slate-200 to-slate-300 rounded-xl flex items-center justify-center text-slate-600">
                                <p className="text-center px-6">Interactive platform screenshot coming soon</p>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 justify-center items-center text-center gap-4">
                            <h2 className="text-4xl lg:text-5xl lilita text-slate-900">
                                INTERNSHIP SEARCH MADE SIMPLE
                            </h2>
                            <p className="text-lg md:text-xl max-w-lg text-slate-700 lilita">
                                A full-stack SaaS platform built to help French students find and track internship opportunities effortlessly.
                            </p>
                            <p className="text-slate-600">(Scroll down to see more)</p>
                        </div>
                    </div>
                </div>

                <div className="sticky top-0 h-[110vh] flex flex-col items-center pt-16 md:pt-28 bg-gradient-to-b from-teal-700 to-cyan-700 text-white">
                    <div className="flex flex-col lg:flex-row items-center justify-center mx-2 md:mx-6 lg:mx-16 xl:mx-48 gap-10 lg:gap-32 object-contain">
                        <div className="flex justify-center h-[50vh] md:h-[60vh] lg:h-[70vh]">
                            <div className="w-full bg-white/10 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                <p className="text-center px-6">Interactive map showcase coming soon</p>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 justify-center items-center text-center gap-4">
                            <h2 className="text-4xl lg:text-5xl lilita">
                                1.4M COMPANIES AT A GLANCE
                            </h2>
                            <p className="text-lg md:text-xl max-w-lg">
                                Interactive geolocation map of all 1.4M French establishments from the SIRENE database. Filter, search, and discover internship opportunities by region, sector, and company size.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="sticky top-0 h-[110vh] flex flex-col items-center pt-16 md:pt-28 bg-gradient-to-b from-indigo-800 to-blue-800 text-white">
                    <div className="flex flex-col lg:flex-row items-center justify-center mx-2 md:mx-6 lg:mx-16 xl:mx-48 gap-10 lg:gap-32 object-contain">
                        <div className="flex justify-center h-[50vh] md:h-[60vh] lg:h-[70vh]">
                            <div className="w-full bg-white/10 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                <p className="text-center px-6">Kanban board showcase coming soon</p>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 justify-center items-center text-center gap-4">
                            <h2 className="text-4xl lg:text-5xl lilita">
                                TRACK YOUR APPLICATIONS
                            </h2>
                            <p className="text-lg md:text-xl max-w-lg">
                                Kanban board to manage your internship applications with status tracking, reminders, and notes. Stay organized throughout your search journey.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="sticky top-0 h-[110vh] flex flex-col items-center justify-center bg-gradient-to-b from-slate-900 to-slate-800 text-white">
                    <div className="flex flex-col items-center justify-center mx-2 md:mx-6 lg:mx-16 xl:mx-48 gap-6 text-center">
                        <h2 className="text-4xl lg:text-5xl lilita">
                            SHOWCASE COMING SOON
                        </h2>
                        <div className="max-w-2xl space-y-6 mt-6">
                            <div>
                                <h3 className="text-2xl font-bold mb-2">About This Project</h3>
                                <p className="text-lg text-slate-200 leading-relaxed">
                                    This is a full-stack SaaS platform designed to simplify internship search for French students. The project combines geolocation data processing of 1.4M establishments from the SIRENE database with a complete JWT authentication system and a modern React interface.
                                </p>
                            </div>

                            <div>
                                <h3 className="text-2xl font-bold mb-3">Tech Stack</h3>
                                <div className="flex flex-wrap gap-2 justify-center">
                                    {['Next.js 15', 'NestJS', 'PostgreSQL', 'Prisma', 'TypeScript', 'Leaflet', 'JWT Auth'].map((tech) => (
                                        <span key={tech} className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm border border-white/30">
                                            {tech}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
